import { Component, type ReactNode } from 'react';
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

function CrashNotice() {
  const { t } = useTranslation();
  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" size="small" onClick={() => window.location.reload()}>
          {t('common.crashReload')}
        </Button>
      }
    >
      {t('common.crashTitle')}
    </Alert>
  );
}

/**
 * Une page qui plante au rendu laissait un écran blanc (#66). React n'offre
 * cette capture qu'en composant classe.
 */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false };

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.error('Page crashed:', error);
  }

  render() {
    return this.state.crashed ? <CrashNotice /> : this.props.children;
  }
}
